/*
 * 収益シミュレーションの計算ロジック（純粋関数群）
 * DOM や I/O に触れず、入力のみから出力を決定する
 */

const WITHHOLDING_TAX_RATE = 0.2042;

function parseJapaneseDate(text) {
  return text.replace('年', '/').replace('月', '/').slice(0, -1);
}

export function calculateOperationTermDays(startText, endText) {
  const start = parseJapaneseDate(startText);
  const end   = parseJapaneseDate(endText);
  return (Date.parse(end) - Date.parse(start)) / (24 * 60 * 60 * 1000) + 1;
}

// 通常案件: 税引前収益 = 元本 + 利益、源泉税は taxRate ベース（年利と同じことが多いが UFF 案件では総分配金率が入る）
export function calculateStandardSimulation({ capitalAmount, profitRate, taxRate, operationTermDays }) {
  const profit    = capitalAmount * (profitRate * 0.01) * (operationTermDays / 365);
  const taxBase   = capitalAmount * (taxRate   * 0.01) * (operationTermDays / 365);
  const beforeTax = Math.floor(profit + capitalAmount);
  const tax       = Math.floor(taxBase * WITHHOLDING_TAX_RATE);
  const afterTax  = beforeTax - tax;
  return { beforeTax, tax, afterTax };
}

// TSON UFF 案件: 税引前収益は総分配金（年利+UFF率）で算出。源泉税は実際の支払い（整数円）に税率を掛けて切り捨てる本則計算に合わせる
// grossDistributionRate は「年利 + UFF率」の合算（呼び出し側は project.simulation_tax_rate を渡す）
export function calculateUpfrontFeeSimulation({ capitalAmount, upfrontFeeRate, grossDistributionRate, operationTermDays }) {
  const grossDistribution = capitalAmount * (grossDistributionRate * 0.01) * (operationTermDays / 365);
  const upfrontFeeAmount  = capitalAmount * (upfrontFeeRate         * 0.01) * (operationTermDays / 365);
  const principal  = capitalAmount;
  const beforeTax  = Math.floor(grossDistribution);
  const upfrontFee = Math.floor(upfrontFeeAmount);
  const tax        = Math.floor(beforeTax * WITHHOLDING_TAX_RATE);
  const afterTax   = beforeTax - upfrontFee - tax;
  return { principal, beforeTax, upfrontFee, tax, afterTax };
}

// negative=true は控除項目の表示用（常に '¥-' を付与）。それ以外は金額の符号を反映する。
// 0 のときは符号なしの '¥0' を返す（'¥-0' を避ける）
export function formatYen(amount, { negative = false } = {}) {
  if (amount === 0) {
    return '¥0';
  }
  if (negative || amount < 0) {
    return '¥-' + Math.abs(amount).toLocaleString();
  }
  return '¥' + amount.toLocaleString();
}
